import React from "react";
import "./ServiceSlider.css";



function ServiceSlider() {
  return (
    <div className="slider">
      <div className="slidenew-track">
        <div className="slidenew">
          <h4 style={{color:"#DA0000"}}>Laser</h4>
        </div>
        <div className="slidenew">
   <h4 style={{color:"#032fc0"}}>Hair Treetment</h4>
        </div>
        <div className="slidenew">
         <h4 style={{color:"#00bdda"}}>Skin Treetment</h4>
        </div>

        {/* Duplicate logos for smooth infinite effect */}
        <div className="slidenew">
      <h4 style={{color:"#a8037f"}}>Cosmetic Surgery</h4>
        </div>
        <div className="slidenew">
           <h4 style={{color:"#daab00"}}>Laser</h4>
        </div>
        <div className="slidenew">
         <h4 style={{color:"#DA0000"}}>Hair Treetment</h4>
        </div>
      </div>
    </div>
  );
}

export default ServiceSlider;
